import { render } from "./FragmentReceiver.vue?vue&type=template&id=6d32eff0&scoped=true&ts=true"
import script from "./FragmentReceiver.vue?vue&type=script&lang=ts"
export * from "./FragmentReceiver.vue?vue&type=script&lang=ts"

import "./FragmentReceiver.vue?vue&type=style&index=0&id=6d32eff0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d32eff0"]])

export default __exports__